'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/edit/PenIcon.tsx
import { jsx } from "react/jsx-runtime";
var PenIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.7248 1.64137C13.9689 1.39729 14.3646 1.39729 14.6087 1.64137L18.3587 5.39137C18.6028 5.63545 18.6028 6.03118 18.3587 6.27525L6.48369 18.1503C6.36648 18.2675 6.20751 18.3333 6.04175 18.3333H2.29175C1.94657 18.3333 1.66675 18.0535 1.66675 17.7083V13.9583C1.66675 13.7926 1.7326 13.6336 1.84981 13.5164L13.7248 1.64137ZM11.9256 5.20831L14.7917 8.07443L17.0329 5.83331L14.1667 2.9672L11.9256 5.20831ZM13.9079 8.95831L11.0417 6.0922L2.91675 14.2172V17.0833H5.78286L13.9079 8.95831Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  PenIcon
};
//# sourceMappingURL=chunk-5ZNH3EJF.mjs.map